import Footer from 'components/desktop/shared/footer';
import Header2 from 'components/desktop/shared/header2';
import { SITE_MAP } from 'globalConstants';
import { Fragment } from 'react';
import Breadcrumb from '../shared/breadcrumb';
import ECommerceHeader from '../shared/e-commerce-header';
import MainContent from './main-content';

const ECommerceListCompany = () => (
  <Fragment>
    <Header2 />
    <ECommerceHeader />
    <main className='flex min-h-[1000px] min-w-[1052px] flex-col'>
      <div className='my-[28px] flex flex-col'>
        <div className='container mx-auto min-w-[1052px] px-[48px] px-[54px] screen-1140:px-[98px] xl:px-[48px] screen-1366:px-[83px] space-y-[24px]'>
          <div className='border-b border-stroke pb-[12px]'>
            <Breadcrumb
              breadcrumbs={[
                { name: 'Trang chủ', slug: SITE_MAP.E_COMMERCE.INDEX },
                { name: 'Nhà cung cấp' },
              ]}
            />
          </div>
          <div className='relative pb-[17px] border-b border-stroke before:absolute before:content-[""] before:h-[2px] before:w-[87px] before:left-0 before:bottom-[-1px] before:bg-e-commerce-rating'>
            <h1 className='text-[24px] leading-[30px] font-[600]'>Nhà cung cấp</h1>
          </div>
          <MainContent />
        </div>
      </div>
    </main>
    <Footer />
  </Fragment>
);

export default ECommerceListCompany;
